<mat-card-title>
	INA/ILP Report
	<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlpReport_Overview'"></help-text-btn>
</mat-card-title>
<mat-divider> </mat-divider>
<br>
<mat-card appearance="outlined">
	<div class="row margin-xs">
		<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
			<h2>
				Search Criteria
			</h2>

			<mat-card-content>
				<region-dropdown-two-way [isMultiple]="true" [allowAllRegions]="false" [reset]="resetField"
					[required]="true" [(selectedRegions)]="chosenRegions" #appRegionCode>
				</region-dropdown-two-way>

				<county-dropdown-two-way [isMultiple]="true" [(selectedCounties)]="chosenCounties" [reset]="resetField"
					[required]="false" #appCountyCode [regions]="chosenRegions">
				</county-dropdown-two-way>

				<district-dropdown-two-way [isMultiple]="true" [(selectedSchoolDistricts)]="chosenSchoolDistricts"
					[reset]="resetField" [required]="false" #appSchoolDistrictCode [regions]="chosenRegions"
					[counties]="chosenCounties">
				</district-dropdown-two-way>

				<school-dropdown-two-way [isMultiple]="true" [(selectedSchools)]="chosenSchools" [reset]="resetField"
					#appSchoolsCode [regions]="chosenRegions" [counties]="chosenCounties"
					[schoolDistricts]="chosenSchoolDistricts">
				</school-dropdown-two-way>

				<app-school-year [yearType]="'SchoolYear'" (performancePeriodEvent)="performancePeriodEvent($event)"
					[reset]="resetField" [required]="true">
				</app-school-year>
			</mat-card-content>
			<h2>
				Enrollment Type *
				<help-text-btn class="align-help-text-btn" [helpTextId]="'EnrollmentType'"></help-text-btn>
			</h2>
			<mat-card-content>
				<div class="col-12">
					<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="rAttending">
						Regular School Year - Attending</mat-checkbox><br>
					<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="rNotAttending">
						Regular School Year - Not Attending</mat-checkbox>
				</div>
			</mat-card-content>
		</div>
		<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
			<h2>
				Filters
			</h2>
			<mat-card-content>
				<div class="row">
					<div class="col-12 inline">
						<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="withoutEip">
							Include children without Eligibility in Period (EiP)</mat-checkbox>
						<help-text-btn class="align-help-text-btn"
							[helpTextId]="'IncludeChildrenWithoutEip'"></help-text-btn>
					</div>
					<div class="col-12 inline">
						<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="expiredQad">
							Include children with expired QAD</mat-checkbox>
						<help-text-btn class="align-help-text-btn"
							[helpTextId]="'IncludeChildrenExpiredQad'"></help-text-btn>
					</div>
					<div class="col-12 inline">
						<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="withoutIna">
							Include children without an INA/ILP</mat-checkbox>
						<help-text-btn class="align-help-text-btn"
							[helpTextId]="'IncludeChildrenWithoutInaIlp'"></help-text-btn>
					</div>
				</div>
				<div class="row">
					<hr />
					<div class="col-12">
						<mat-radio-group [(ngModel)]="chosenInaFilter" class="row">
							<div *ngFor="let inaFilter of inaFilters | keyvalue" class="col-12 inline">
								<mat-radio-button class="checkbox-margin-sm" [value]="inaFilter.value.DATA"
									color="primary">
									{{inaFilter.key}}
								</mat-radio-button>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="inaFilter.value.TOOLTIP.ID"></help-text-btn>
							</div>
						</mat-radio-group>
					</div>
				</div>
				<div class="row">
					<hr />
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 inline">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>Filter</mat-label>
							<mat-select [multiple]="true" (openedChange)="updateFilterResults($event)"
								(selectionChange)="checkbox($event.value, inaResultFilters)"
								[(ngModel)]="selectedFilters" [panelClass]="'wide-select-panel'"
								[disabled]="results.length === 0">

								<div class="margin-md text-center row">
									<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
										<button color="primary" mat-raised-button
											(click)="selectAllFilters(inaResultFilters)">
											Select All
										</button>
									</div>
									<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
										<button color="accent" mat-raised-button
											(click)="deSelectAllFilters(inaResultFilters)">
											Deselect All
										</button>
									</div>
								</div>

								<mat-option [value]="filter.key" *ngFor="let filter of inaResultFilters | keyvalue">
									{{filter.key}}
								</mat-option>
							</mat-select>
						</mat-form-field>

						<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlpReport_Filter'"></help-text-btn>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 inline">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>Filter Options</mat-label>
							<mat-select [multiple]="true" (openedChange)="updateFilterResults($event)"
								(selectionChange)="checkboxOption($event.value, inaResultFilters)"
								[(ngModel)]="selectedFilterOptions" [panelClass]="'wide-select-panel'"
								[disabled]="selectedFilters.length === 0">

								<div class="margin-xs text-center row">
									<span *ngFor="let filter of inaResultFilters | keyvalue" class="col-12">
										<button mat-raised-button *ngIf="filter.value.ENABLED" class="margin-bottom-xs"
											[color]="currentFilter === filter.key ? 'primary' : ''"
											(click)="currentFilter = filter.key">{{filter.key}}
											{{filter.value.COUNT > 0 ? '(' + filter.value.COUNT + ')' :
											''}}</button>
									</span>
								</div>

								<div class="margin-md text-center row">
									<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
										<button color="primary" mat-raised-button
											(click)="selectAllOptions(currentFilter)">
											Select All
										</button>
									</div>
									<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
										<button color="accent" mat-raised-button
											(click)="deSelectAllOptions(currentFilter)">
											Deselect All
										</button>
									</div>
								</div>

								<mat-option [hidden]="true">
									Select
								</mat-option>
								<div *ngFor="let filter of inaResultFilters | keyvalue"
									[hidden]="currentFilter !== filter.key">
									<div>
										<mat-option [value]="filter.key + option.FILTER"
											*ngFor="let option of filter.value.OPTIONS">
											{{option.FILTER}}
										</mat-option>
									</div>
								</div>
							</mat-select>
						</mat-form-field>
						<help-text-btn class="align-help-text-btn"
							[helpTextId]="'InaIlpReport_FilterOptions'"></help-text-btn>
					</div>
				</div>
			</mat-card-content>
		</div>
		<mat-card-actions>
			<button mat-raised-button color="primary" mat-button [disabled]="!this.checkValid() || isLoading"
				(click)="search()" class="margin-right-xs">
				<mat-icon *ngIf="isLoading">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Search
			</button>
			<button mat-raised-button color="accent" (click)="reset()" mat-button class="margin-right-xs">Reset</button>
			<button [disabled]="!(results.length > 0) || isExporting" mat-raised-button [matMenuTriggerFor]="menu"
				class="margin-right-xs">
				<mat-icon *ngIf="isExporting">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Export
				<mat-icon *ngIf="!isExporting">more_vert</mat-icon>
			</button>
			<mat-menu #menu="matMenu">
				<button mat-menu-item (click)="downloadExcel()">
					<span>
						<i class="fa fa-file"></i>
						Export to Excel</span>
				</button>
			</mat-menu>
		</mat-card-actions>

	</div>
</mat-card>
<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>

<div *ngIf="results.length > 0" class="margin-top-md">
	<h2>
		INA/ILP Report - {{'(' + currentSchoolYear + ')'}} - ({{(
		tableDataSource ? (tableDataSource.filteredData.length < results.length ? tableDataSource.filteredData.length
			+ '/' : '' ) : '' ) + results.length}} Children) </h2>
			<hr />

			<div class="row">
				<mat-form-field>
					<mat-label>
						Filter
					</mat-label>
					<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
						(ngModelChangeDebounced)="setFilter()" />
				</mat-form-field>
			</div>

			<div class="margin-top-sm">
				<mat-table [dataSource]="tableDataSource" class="mat-elevation-z1 table-responsive" matSort
					(matSortChange)="announceSortChange($event)">

					<ng-container matColumnDef="REGION_CODE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Region
						</mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.REGION_CODE}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> School
						</mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.SCHOOL_NAME}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="INA_REPORT_SECTIONS.PERSONAL_GRADE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Grade
						</mat-header-cell>
						<mat-cell *matCellDef="let element">
							{{element.INA_REPORT_SECTIONS?.PERSONAL_GRADE}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="ENROLLMENT_TYPE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Type
						</mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.ENROLLMENT_TYPE}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="INA_REPORT_SECTIONS.PERSONAL_MSD">
						<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<edit-child-modal-btn [studentId]="element.STUDENTS_ID" [type]="'string'"
								[displayText]="element.INA_REPORT_SECTIONS.PERSONAL_MSD">
							</edit-child-modal-btn>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="INA_REPORT_SECTIONS.PERSONAL_SSID">
						<mat-header-cell *matHeaderCellDef mat-sort-header> SSID </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.INA_REPORT_SECTIONS.PERSONAL_SSID}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="INA_REPORT_SECTIONS.PERSONAL_NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.INA_REPORT_SECTIONS.PERSONAL_NAME}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="INA_REPORT_SECTIONS.PERSONAL_DOB">
						<mat-header-cell *matHeaderCellDef mat-sort-header> DOB </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.INA_REPORT_SECTIONS.PERSONAL_DOB | simpleDate}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="INA_REPORT_SECTIONS.PERSONAL_QAD">
						<mat-header-cell *matHeaderCellDef mat-sort-header> QAD
						</mat-header-cell>
						<mat-cell *matCellDef="let element">
							{{element.INA_REPORT_SECTIONS.PERSONAL_QAD | simpleDate}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="CURRENT_REGION_EOE_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> EoE
						</mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.CURRENT_REGION_EOE_DATE |
							simpleDate}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="DEPARTURE_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Departure Date
						</mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.DEPARTURE_DATE |
							simpleDate}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="STATUS_TYPE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> INA/ILP Status
						</mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.STATUS_TYPE}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="INA_REPORT_SECTIONS.CREATED_BY_FIRST_NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Created By/ Date </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.INA_REPORT_SECTIONS.CREATED_BY_FIRST_NAME}}
							{{element.INA_REPORT_SECTIONS.CREATED_BY_LAST_NAME ?
							element.INA_REPORT_SECTIONS.CREATED_BY_LAST_NAME + ' /' : ''}}
							{{element.INA_REPORT_SECTIONS.CREATED_BY_DATE | simpleDate}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="INA_REPORT_SECTIONS.FOLLOW_UP_BY_FIRST_NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Follow-up by / Date
						</mat-header-cell>
						<mat-cell *matCellDef="let element">
							{{element.INA_REPORT_SECTIONS.FOLLOW_UP_BY_FIRST_NAME}}
							{{element.INA_REPORT_SECTIONS.FOLLOW_UP_BY_LAST_NAME ?
							element.INA_REPORT_SECTIONS.FOLLOW_UP_BY_LAST_NAME + ' /' : ''}}
							{{element.INA_REPORT_SECTIONS.FOLLOW_UP_BY_DATE | simpleDate}}
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns;"
						[ngClass]="{'terminatedRow': row.CURRENT_REGION_EOE_DATE && isQadExpired(row.CURRENT_REGION_EOE_DATE)}"
						[matTooltip]="'QAD Expired'" [matTooltipPosition]="'above'"
						[matTooltipDisabled]="row.CURRENT_REGION_EOE_DATE && !isQadExpired(row.CURRENT_REGION_EOE_DATE)"
						[matTooltipClass]="'terminatedTooltip'"></mat-row>
				</mat-table>

				<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20,100]" showFirstLastButtons
					aria-label="Select page of periodic elements">
				</mat-paginator>
			</div>
</div>